"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSubscriptionCheckoutContextType_Invitation = void 0;
var UserSubscriptionCheckoutContextType_Invitation;
(function (UserSubscriptionCheckoutContextType_Invitation) {
    UserSubscriptionCheckoutContextType_Invitation["INVITATION"] = "invitation";
})(UserSubscriptionCheckoutContextType_Invitation || (exports.UserSubscriptionCheckoutContextType_Invitation = UserSubscriptionCheckoutContextType_Invitation = {}));
